export type TagType = (typeof TAG_TYPES)[number];

export const TAG_TYPES = [
  "action",
  "activity",
  "alert",
  "api-key",
  "bookmark",
  "cache-config",
  "card",
  "channel",
  "cloud-migration",
  "collection",
  "collection-tree",
  "content-diagnostics-finding",
  "content-translation",
  "custom-viz-plugin",
  "dashboard",
  "dashboard-question-candidates",
  "data-app",
  "database",
  "dataset",
  "document",
  "embed-theme",
  "erd",
  "external-transform",
  "public-document",
  "comment",
  "setup-guide-checklist",
  "exploration",
  "field",
  "field-values",
  "git-sync",
  "glossary",
  "indexed-entity",
  "table-index",
  "llm-models",
  "llm-providers",
  "logger-preset",
  "measure",
  "metric-dimension",
  "mfa-status",
  "model-index",
  "notification",
  "oauth-authorization",
  "parameter-values",
  "permissions-group",
  "persisted-info",
  "persisted-model",
  "revision",
  "group-table-access-policy",
  "schema",
  "segment",
  "session-properties",
  "slack-app-info",
  "snippet",
  "subscription",
  "subscription-channel",
  "table",
  "task",
  "task-run",
  "timeline",
  "timeline-event",
  "transform",
  "transform-tag",
  "transform-job",
  "transform-job-via-tag",
  "transform-run",
  "transform-dag-run",
  "transform-inspector-lens",
  "user",
  "current-user",
  "user-homepage-dashboard",
  "public-dashboard",
  "embed-dashboard",
  "public-card",
  "embed-card",
  "public-action",
  "unique-tasks",
  "user-key-value",
  "tenant",
  "metabot",
  "metabot-conversations",
  "metabot-entities-list",
  "metabot-prompt-suggestions",
  "metabot-permissions",
] as const;

export const TAG_TYPE_MAPPING = {
  collection: "collection",
  "content-translation": "content-translation",
  card: "card",
  dashboard: "dashboard",
  database: "database",
  document: "document",
  "indexed-entity": "indexed-entity",
  measure: "measure",
  table: "table",
  dataset: "card",
  action: "action",
  segment: "segment",
  metric: "card",
  snippet: "snippet",
  pulse: "subscription",
  transform: "transform",
  exploration: "exploration",
  "data-app": "data-app",
} as const;
